import EventLiabilityWidget from './EventLiabilityWidget.vue';

export default EventLiabilityWidget;
